if (!customElements.get('mg-home-video')) {
  customElements.define('mg-home-video', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.video = this.querySelector('video');
      this.button = this.querySelector('.mg-video-toggle');
      if (!this.video || !this.button) return;
      this.preference = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.preference.matches;
      this.inView = true;
      this.video.muted = true;
      this.reflect = () => {
        const playing = !this.video.paused;
        this.button.setAttribute('aria-pressed', String(playing));
        this.button.querySelector('[data-video-pause]').hidden = !playing;
        this.button.querySelector('[data-video-play]').hidden = playing;
      };
      this.sync = () => {
        if (this.userPaused || document.hidden || !this.inView) this.video.pause();
        else this.video.play().catch(() => this.reflect());
        this.reflect();
      };
      this.toggle = () => {
        this.userPaused = !this.video.paused;
        this.sync();
      };
      this.changed = () => {
        this.userPaused = this.preference.matches;
        this.sync();
      };
      this.button.hidden = false;
      this.button.addEventListener('click', this.toggle);
      this.video.addEventListener('play', this.reflect);
      this.video.addEventListener('pause', this.reflect);
      document.addEventListener('visibilitychange', this.sync);
      this.preference.addEventListener('change', this.changed);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.sync();
      });
      this.observer.observe(this);
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.toggle);
      this.video?.pause();
      this.video?.removeEventListener('play', this.reflect);
      this.video?.removeEventListener('pause', this.reflect);
      document.removeEventListener('visibilitychange', this.sync);
      this.preference?.removeEventListener('change', this.changed);
      this.ready = false;
    }
  });
}
